import React from 'react';
import {motion} from 'framer-motion';
import {useLocation} from 'react-router-dom';

const galleries={
  '/menrx': {
    label: 'Care that supports your everyday life',
    title: 'Private care,with a more personal touch.',
    images: [
      {src: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=1200&q=90',alt: 'Confident man enjoying his day'},
      {src: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&w=1200&q=90',alt: 'Man feeling confident and at ease'}
    ],
    tone: 'from-sky-950 via-sky-900 to-teal-900'
  },
  '/hairrx': {
    label: 'Confidence is personal',
    title: 'Care designed to help you feel like yourself.',
    images: [
      {src: 'https://images.unsplash.com/photo-1544725176-7c40e5a71c5e?auto=format&fit=crop&w=1200&q=90',alt: 'Confident man with healthy hair'},
      {src: 'https://images.unsplash.com/photo-1507591064344-4c6ce005b128?auto=format&fit=crop&w=1200&q=90',alt: 'Man enjoying a healthy hair-care routine'}
    ],
    tone: 'from-teal-950 via-teal-800 to-cyan-800'
  }
};

export default function SpecialtyImageGallery() {
  const {pathname}=useLocation();
  const gallery=galleries[pathname];

  if (!gallery) return null;

  return (
    <section className={`overflow-hidden bg-gradient-to-br ${gallery.tone} py-20 text-white sm:py-24`}>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <p className="text-sm font-extrabold uppercase tracking-[0.2em] text-white/65">{gallery.label}</p>
          <h2 className="mt-4 text-4xl font-extrabold tracking-tight sm:text-5xl">{gallery.title}</h2>
        </div>
        <div className="mt-12 grid gap-6 md:grid-cols-2">
          {gallery.images.map((image,index)=> (
            <motion.div key={image.src} initial={{opacity: 0,y: 22}} whileInView={{opacity: 1,y: 0}} viewport={{once: true}} transition={{delay: index * 0.12}} className="group overflow-hidden rounded-[2rem] border border-white/15 bg-white/10 shadow-2xl">
              <img src={image.src} alt={image.alt} className="h-72 w-full object-cover transition duration-700 group-hover:scale-105 sm:h-96" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}